// extracted by mini-css-extract-plugin
export default {"fieldTitle":"TextItems_fieldTitle__sfi7p","fieldValue":"TextItems_fieldValue__+CMmZ"};